<div>
  <mat-dialog-content>
    <div class="content">
      <div class="header">
        <h2 mat-dialog-title>Remove user</h2>
      </div>
      <span class="card-subtitle t4 mb-2 mt-2 text-muted">Are you sure you want to remove <b>{{ username }}?</b>
      </span>
    </div>
    <mat-divider></mat-divider>
    <div class="actions">
      <button class="btn btn-link col-4" mat-button mat-dialog-close>
        CANCEL
      </button>
      <button class="btn button btn-primary btn-block col-6" mat-button [mat-dialog-close]="true" cdkFocusInitial>
        REMOVE
      </button>
    </div>
  </mat-dialog-content>
</div>